export function getAuthRetryTarget(origin: string): string {
  return origin
}
